import { popupDismissConstants } from '../constants';
import { 
  controlledGETRequest, 
  createCancelToken, 
  controlledFormDataPUTRequest
} from '../utils/Axios';

export const dismiss_popupActions = {
  getDismissPopupDetail,
  updateDismissPopupDetail
};

export function getDismissPopupDetail({
  cancel_token = createCancelToken().token,
  ...props
}) {
  return function (dispatch) {
    try{
        
        controlledGETRequest(`/api/v1/popup_dismisses`, cancel_token)
        .then(response => {
            if(response.data.status === "ok"){
                props?.onSuccess?.(response)
            }else {
                props?.onError?.(response)
            }
        })
    }catch(e){
      dispatch( {
        type: popupDismissConstants.POPUP_DISMISS_FAILURE,
        payload: console.log(e),
      })
    }
  }
}


export function updateDismissPopupDetail({
    id,
    formData,
    cancel_token = createCancelToken().token,
    ...props
}) {
  return function (dispatch) {
    try{
      controlledFormDataPUTRequest(`/api/v1/popup_dismisses/${id}`, cancel_token, { popup_dismiss: formData })
      .then(response => {
        if(response.data.status === "ok"){
            props?.onSuccess?.(response)
        }else {
            props?.onError?.(response)
        }
      })
    }catch(e){
      dispatch( {
        type: popupDismissConstants.POPUP_DISMISS_FAILURE,
        payload: console.log(e),
      })
    }
  }
}
